export { default as AdPlacement } from './AdPlacement';
export { default as ClientPlacedAd } from './VgClientPlacedAd';
export { default as SponsorAd } from './SponsorAd';
export { default as HorseshoeAd } from './HorseshoeAd';



/** WEBPACK FOOTER **
 ** ./src/local-components/Ads/index.js
 **/